export class AuthEndPoints{
    static Register = `api/website/auth/register`;
    static Login = `api/website/auth/login`;
    static ResetPassword = `api/website/auth/reset-password`;
    static SendOTP = `api/website/auth/send-otp`;
    static VerifyOTP = `api/website/auth/verify-otp`;
    
}